import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';


/**
 * Width directive change the width of the html element
 * Its goal is to avoid the multitude of class css creation
 * Exemple :
 * <div witdh=100%></div>
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[height]',
})
export class WizHeightDirective implements OnInit {
  @Input() height: string;


  constructor(private elementRef: ElementRef, private  renderer: Renderer2) { }

  ngOnInit(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'height', this.height);

    // Check type of width
    // The flex-shrink property defines the shrinkage factor of a flexible element
    try{
      if (this.height.indexOf( 'px' ) > -1) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'min-height', this.height);
        this.renderer.setStyle(this.elementRef.nativeElement, 'flex-basis', this.height);
        this.renderer.setStyle(this.elementRef.nativeElement, 'flex-shrink', 0);
      } else { //height en %
        this.renderer.setStyle(this.elementRef.nativeElement, 'flex-shrink', 1);
      }
    } catch(e: any) {
      // console.log('dir height', e, this);
    }


  }
}
